/* eslint-disable prefer-arrow-callback */
/* eslint-disable no-lonely-if */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  Button,
  Dialog,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
  tableCellClasses,
  Paper,
  Grid,
  Stack,
  styled,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Divider,
  Chip,
  Autocomplete,
  Checkbox,
  DialogActions,
  DialogTitle,
  DialogContent,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import countries from 'i18n-iso-countries';
import { getCountryCallingCode } from 'libphonenumber-js';
import moment from 'moment';
import { saveAs } from 'file-saver';
import { Form, Formik } from 'formik';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import { Container } from 'reactstrap';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { Email, Phone, LocationOn } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import PortraitIcon from '@mui/icons-material/Portrait';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import useMediaQuery from '@mui/material/useMediaQuery';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import imagepreview from '../../../media/upload.png';
import NoimageFound from '../../../media/noimage.jpg';
import axios from '../../../utils/axios';
import UIContext from '../../../context/UIContext';
import NoResultsFound from '../../../components/NoResultsFound';
import LedgerAdd from '../Common/LedgerAdd';


const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const StyledTableCell = styled(TableCell)({
  color: 'white',
  fontWeight: '600',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#257180',
  },
  whiteSpace: 'nowrap',
});

const StyledTableCell2 = styled(TableCell)({
  color: 'white',
  fontWeight: '600',
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#8EB486',
  },
  whiteSpace: 'nowrap',
});

const useStyles = styled((theme) => ({
  fileInput: {
    display: 'none',
  },
  chooseFileButton: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

const Countrys = {
  INDIA: 'IN',
  'UNITED KINGDOM': 'UK',
};

const idCardTypes = [
  { id: 0, name: 'Select' },
  { id: 1, name: 'Voters ID Card' },
  { id: 2, name: 'Driving License' },
  { id: 3, name: 'PAN Card' },
  { id: 4, name: 'Ration Card' },
  { id: 5, name: 'Aadhar Card' },
  { id: 6, name: 'Passport' },
  { id: 7, name: 'VISA' },
  { id: 8, name: 'Refugee Card' },
  { id: 9, name: 'NIC' },
  { id: 10, name: 'Residence Permit' },
];

const statusOptions = [
  { label: 'All', value: '0' },
  { label: 'Hot', value: 'H' },
  { label: 'Cold', value: 'C' },
  { label: 'Warm', value: 'W' },
];

const resetStates = {
  fullName: '',
  dob: '',
  addr1: '',
  addr2: '',
  addr3: '',
  coo: 'IN',
  branch: '',
  tel: '',
  alterTel: '',
  mailid: '',
  city: '',
  state: '',
  country: '',
  pincode: '',
  requested_date: '',
  salesPerson: '',
  remarks: '',
  idCardType: '',
  IdCardNo: '',
  IDcardFile: null,
  LeadStatus: '',
  WebAccess: '',
  ExpiryDate: '',
  isActive: true,
  referedby:  '',
  referother: ''
};

const SalesFollowupPanel = () => {
  const theme = useTheme();
  const classes = useStyles();
  const smallScreens = useMediaQuery(theme.breakpoints.down('md'));
  // snackbar context
  const { openSnackBar, showLoading, hideLoading } = useContext(UIContext);

  // handling image file
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB (adjust as needed)
  const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png'];
  const [selectedImageFile, setSelectedImageFile] = useState('');
  const [imagePreview, setImagePreview] = useState('');

  // popup controls
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [open, setOpen] = useState(false);

  // filters data
  const [status, setStatus] = useState('0'); // Filter for status
  const [companyId, setCompanyId] = useState(sessionStorage.getItem('CompanyId'));
  const [searchType, setSearchType] = useState('name');
  const [searchValue, setSearchValue] = useState('');
  const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
  const [dateFilterType, setDateFilterType] = useState('R');
  const [fromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(moment().format('YYYY-MM-DD'));

  // load & manage data states
  const [initialValue, setInitialValue] = useState(resetStates);
  const [getDataForView, setGetDataForView] = useState([]);
  const [oneCustomerFollowUps, setOneCustomerFollowUps] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [filtersData, setFiltersData] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [editID, setEditID] = useState('');
  const [salesPersons, setSalesPersons] = useState([]);
  const [isDialogOpen, setDialogOpenState] = useState(false);
  const [allCustomerData, setAllCustomerData] = useState([]);

  // pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { totalRows, currentPage } = useMemo(() => {
    const totalRows = getDataForView.length;
    const totalPages = Math.ceil(totalRows / rowsPerPage);
    const currentPage = Math.max(0, Math.min(page, totalPages - 1));
    return { totalRows, currentPage };
  }, [getDataForView, page, rowsPerPage]);

  // State to manage new follow-up details
  const [newFollowUp, setNewFollowUp] = useState({
    customerId: null,
    createdDateTime: null,
    followUpDateTime: '',
    remarks: '',
    action: '',
  });
  const [fieldErrors, setFieldErrors] = useState({ followUpDateTime: false });
  const [isEditing, setIsEditing] = useState(false);
  const [editingRowId, setEditingRowId] = useState(null);
  const [rowDeleteID, setRowDeleteID] = useState(null);
  const [openFollowUpTable, setOpenFollowUpTable] = useState(null);
  const [ledgerDetails, setLedgerDetails] = useState(null);
  const [customerEmailidData, setCustomerEmailidData] = useState([]);
  const [telCode, setTelCode] = useState('  ');
  const [referedby, setReferedby] = useState([]);
  const [oldData,setOldData] = useState([]);

  const GetCountryList = async () => {
    try {
      const res = await axios.post('/signup/GetCountryList');

      setCountryList(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

     const GetReferedby = async () => {
      try {
        const response = await axios.post('signUp/GetReferedby', {});
        // const data = response.data;
        setReferedby(response.data);
      } catch (err) {
        console.error(err);
      }
    }

  const getStateList = async (countryid) => {
    try {
      if (!countryid) return;
      const res = await axios.get(`/signup/GetAllState/${countryid}`);
      setStateList(res.data);
    } catch (err) {
      console.log(err.message);
      setStateList([]);
    }
  };

  const findTelCode = (countryName) => {
    try {
      const countryCode = countries.getAlpha2Code(countryName, 'en');
      setTelCode(`+${getCountryCallingCode(countryCode)}`);
    } catch {
      setTelCode('  ');
    }
  };

  const GetSalesExecutives = async (origin) => {
    try {
      const res = await axios.get('/Approval/LoginApprovalRoute/GetAllSalesExecutive', {
        headers: {
          Country: origin,
        },
      });
      setSalesPersons(res.data);
    } catch (err) {
      setSalesPersons([]);
    }
  };

  const GetCustomerHelp = async () => {
    try {
      const userID = sessionStorage.getItem('UserId');
      // const branchID = sessionStorage.getItem('BranchId');
      const res = await axios.get(`/Transactions/SalesControls/GetCustomerHelpForSE/${companyId}/${userID}/0`);
      setFiltersData(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };

  const GetCustomerHelpAll = async () => {
    try {
      const res = await axios.get('Approval/LoginApprovalRoute/GetAllWindowsCustomer');
      setAllCustomerData(res.data);
    } catch (err) {
      console.log(err.message);
    }
  };
function getNameById(id) {
    const cardType = idCardTypes.find((item) => item.id === id);
    return cardType ? (cardType.name === 'Select' ? '' : cardType.name) : 'ID not found';
  }
  const getIdCardNameById = (id) => {
    // Find the ID card type based on the provided id
    const idCard = idCardTypes.find((card) => (card.id) === (id));

    // If found, return the name, otherwise return an empty string or any fallback value
    return idCard ? idCard.name : '';
  };

  async function GetBranchList(cntry) {
    try {
      const requestData = {
        CompanyId: 4,
      };

      const config = {
        headers: {
          Country: cntry,
        },
      };
      showLoading();
      const response = await axios.post('signup/GetBranchList', requestData, config);
      const {data} = response;
      setBranchList(data.filter((i) => i.webBranch !== 'N' && i.BranchName.trim().toLowerCase() !== 'other'));
    } catch (e) {
      openSnackBar(e.response?.data?.message || 'Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  async function getAllData() {
    if (!validateFilters()) {
      return; // If validation fails, stop the request
    }
    try {
      showLoading();
      const CusID = filtersData.find((card) => card.CUSTOMERNAME.toLowerCase() === searchValue.toLowerCase());
      const customerId = searchType === 'name' && CusID ? CusID.CUSTOMERID : '0';
      const phoneNo = searchType === 'phone' && searchValue ? searchValue : '0';
      const userID = sessionStorage.getItem('UserId');
      // const branchID = sessionStorage.getItem('BranchId');

      const requestData = {
        customerId,
        userId: userID,
        branchId: 0,
        phoneNo,
        companyId,
        LeadStatus: status,
        fromDate: moment(fromDate).format('YYYYMMDD'),
        toDate: moment(toDate).format('YYYYMMDD'),
        dateFilterType,
      };
      const response = await axios.post(`/Transactions/SalesControls/GetMyFollowUpCustomers`, requestData);
      setGetDataForView(response.data);
    } catch (e) {
      openSnackBar(e.response?.data || 'Something went wrong! Try again.', 'error');
    }
    hideLoading();
  }

  const GetExcel = async () => {

    if (!validateFilters()) {
      return; // If validation fails, stop the request
    }
    try {
      showLoading();
      const CusID = filtersData.find((card) => card.CUSTOMERNAME.toLowerCase() === searchValue.toLowerCase());
      const customerId = searchType === 'name' && CusID ? CusID.CUSTOMERID : '0';
      const customerName = searchType === "name" && CusID ? CusID.CUSTOMERNAME : "";
      const phoneNo = searchType === 'phone' && searchValue ? searchValue : '0';
      const userID = sessionStorage.getItem('UserId');
      // const branchID = sessionStorage.getItem('BranchId');

      const requestData = {
        customerId,
        customerName,
        searchType,
        userId: userID,
        branchId: 0,
        phoneNo,
        companyId,
        LeadStatus: status,
        fromDate: moment(fromDate).format('YYYYMMDD'),
        toDate: moment(toDate).format('YYYYMMDD'),
        dateFilterType,
      };
      const response = await axios.post(`/Transactions/SalesControls/GetExcel`, requestData,
        { responseType: "blob" },
      )
      const excelBlob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      });
      saveAs(excelBlob, `Ledger Followup Panel-${moment(new Date()).format('MMMM Do YYYY, h-mm a')}`);
      setTimeout(() => {
        hideLoading();
      }, 2000);

    } catch (error) {
      if (error.response?.status === 404) {
        openSnackBar('No records found to export.', 'error');
      } else {
        openSnackBar('Something went wrong! Try again.', 'error');
      }
    }
    hideLoading();
  }

  const handleCountryChange = (value) => {
    if (!value) return;
    setStateList([]);
    getStateList(value.CountryId);
    findTelCode(value.CountryName);
  };

  const handleFileChange = (event, fileType) => {
    const file = event.target.files[0];

    // File size validation
    if (file.size > MAX_FILE_SIZE) {
      alert('File size exceeds the maximum allowed size (5 MB).');
      return;
    }

    // File type validation
    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      alert('Invalid file type. Allowed types are JPEG, PNG, and PDF.');
      return;
    }

    // Update the selected file and error state based on the fileType
    if (fileType === 'photo') {
      setSelectedImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  useEffect(() => {
    getAllData();
    GetCountryList();
    GetCustomerHelp();
    GetCustomerHelpAll();
    GetSalesExecutives(sessionStorage.getItem('country'));
    GetReferedby();
  }, []);

  const fetchAutoCompleteOptions = (value) => {
    if (!value.trim()) {
      setAutoCompleteOptions([]); // Clear options if input is empty
      return;
    }

    const filteredOptions = filtersData.filter(
      (item) =>
        searchType === 'name'
          ? item.CUSTOMERNAME.toLowerCase().includes(value.toLowerCase())
          : item.Phone && item.Phone.includes(value) // Handle empty Phone fields
    );

    const formattedOptions = filteredOptions.map((item) => ({
      label: searchType === 'name' ? item.CUSTOMERNAME : item.Phone || 'No Phone Available',
      value: item.CUSTOMERID,
      details: searchType === 'name' ? item.CUSTOMERNAME : item.Phone,
    }));

    setAutoCompleteOptions(formattedOptions);
  };

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    resetFollowUpState();
  };

  // Handle follow-up change for remarks
  const handleFollowUpChange = (e) => {
    setNewFollowUp({ ...newFollowUp, remarks: e.target.value });
  };

  const handleFollowUpDateTimeChange = (e) => {
    // Simply use the input value as is, no need to adjust time zones
    const newDate = e.target.value;
    setNewFollowUp({ ...newFollowUp, followUpDateTime: newDate });

    // Validate if the selected date and time is in the future
    const currentDate = new Date();
    const selectedDate = new Date(newDate);
    const isValidDate = selectedDate >= currentDate;

    setFieldErrors((prevFieldErrors) => ({
      ...prevFieldErrors,
      followUpDateTime: !isValidDate,
    }));
  };

  async function InsertCustomerTimeLine() {
    const localDate = new Date(newFollowUp.followUpDateTime);
    const utcDate = new Date(localDate.getTime() - localDate.getTimezoneOffset() * 60000);
    const followupDateUTC = utcDate.toISOString(); // Convert to "YYYY-MM-DDTHH:mm:ss.sssZ"
    if (isEditing) {
      const newData = {
        Optype: 'Edit',
        followupDate: new Date(newFollowUp.followUpDateTime).toLocaleString(),
        remarks: newFollowUp.remarks,
        modifiedBy: sessionStorage.getItem('UserId'),
        modifiedOn: new Date(),
        timelineId: editingRowId,
      };
      try {
        showLoading();
        const response = await axios.post('Transactions/Customer_Timeline/InsertCustomerTimeline', newData);
        if (response.status === 200) {
          // openSnackBar('Customer Timeline Updated Successfully!', 'success');
        }
      } catch (e) {
        openSnackBar('Something Went Wrong try Again !', 'error');
      }
      hideLoading();
    } else {
      const newData = {
        Optype: 'New',
        customerId: ledgerDetails.CUSTOMERID,
        companyId: sessionStorage.getItem('CompanyId'),
        branchId: 0,
        Order_ID: 0,
        Order_Type: '',
        remarks: newFollowUp.remarks,
        followup: 'Ledger Follow Up',
        // followupDate: new Date(newFollowUp.followUpDateTime).toLocaleString(),
        followupDate: followupDateUTC,
        createdBy: sessionStorage.getItem('UserId'),
        createdOn: new Date().toISOString(),
      };
      try {
        showLoading();
        const response = await axios.post('Transactions/Customer_Timeline/InsertCustomerTimeline', newData);
        if (response.status === 200) {
          // openSnackBar('Customer Timeline Created Successfully!', 'success');
        }
      } catch (e) {
        openSnackBar('Something Went Wrong try Again !', 'error');
      }
      hideLoading();
    }
    setOpenDialog(false);
    await GetOneCustomerTimeline(ledgerDetails);
    resetFollowUpState();
  }

  const handleDeleteFollowUp = async () => {
    showLoading();
    try {
      const response = await axios.delete(`Transactions/Customer_Timeline/DeleteCustomerTimeline/${rowDeleteID}`);
      if (response.status === 200) {
        openSnackBar('Record Deleted successfully !', 'error');
      }
      hideLoading();
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
      hideLoading();
    }
    GetOneCustomerTimeline(ledgerDetails);
    setRowDeleteID(null);
  };

  // Handle Edit Button Click
  const handleEditFollowUp = (editData) => {
    if (editData) {
      const formattedDate = moment.utc(editData.followupDate).local().format('YYYY-MM-DDTHH:mm');

      // Set the form fields with the formatted date and other values
      setNewFollowUp({
        followUpDateTime: formattedDate, // Set the formatted date for the edit
        remarks: editData.remarks,
      });
      setEditingRowId(editData.timelineId);
      setIsEditing(true);
      setOpenDialog(true);
    }
  };

  const handleFollowUpTableToggle = (rowIndex, data) => {
    setLedgerDetails(data);
    GetOneCustomerTimeline(data);
    setOpenFollowUpTable(true);
  };

  const handleOpenConfirmDialog = (boxIndex) => {
    setRowDeleteID(boxIndex); // Set the box to be deleted
    setOpenConfirmDialog(true); // Open the confirmation dialog
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false); // Close the confirmation dialog
    setRowDeleteID(null);
    resetFollowUpState();
  };

  const handleConfirmDelete = () => {
    if (rowDeleteID !== null) {
      handleDeleteFollowUp(rowDeleteID); // Call the delete function
    }
    handleCloseConfirmDialog(); // Close the confirmation dialog
  };

  async function GetOneCustomerTimeline(customerData) {
    try {
      showLoading();
      // const response = await axios.get(
      //   `/Transactions/Customer_Timeline/GetOneCustomerTimeline/${customerData.CUSTOMERID}/${sessionStorage.getItem(
      //     'BranchId'
      //   )}/${sessionStorage.getItem('UserId')}`
      // );
      // const response = await axios.post(
      //   `/Transactions/Customer_Timeline/GetOneCustomerTimeline/${customerData.CUSTOMERID}/0/${sessionStorage.getItem(
      //     'UserId'
      //   )}/${customerData.ExpiryDate}`
      // );
      const response = await axios.post(
        `/Transactions/Customer_Timeline/GetOneCustomerTimeline`, {
        'customerId': customerData.CUSTOMERID,
        'branchId': 0,
        'userId': sessionStorage.getItem('UserId'),
        'ExpiryDate': customerData.ExpiryDate
      }
      );
      setOneCustomerFollowUps(response.data);
    } catch (e) {
      openSnackBar(e.response?.data || 'Something went wrong! Try again.', 'error');
    }
    hideLoading();
  }

  const handleReviewClick = async (data) => {
    setOldData(data);
    setEditID(data.CUSTOMERID);
    const response = await axios.get(`/Approval/LoginApprovalRoute/GetSalesPerson/${data.CUSTOMERID}`);

    GetBranchList(data.Origin);
    let stateList = [];
    try {
      // Fetch state list based on the country ID
      const stateResponse = await axios.get(`/signup/GetAllState/${data.COUNTRYID}`);
      stateList = stateResponse.data;
      setStateList(stateList);
    } catch (err) {
      console.log(err.message);
      setStateList([]);
    }
    // Find the state from the stateList based on the StateId
    const selectedState = stateList.find((state) => state.StateId === data.STATEID) || null;

    if (sessionStorage.getItem('Origin') === 'IN') {
      if (data.IDCARDNO && data.IDCARDTYPE) {
        const ts = Date.now();
        const url = `${axios.defaults.inImageURL}/MT${data.IDCARDNO}-${getIdCardNameById(data.IDCARDTYPE)}.jpg`;
        setImagePreview(`${url}${url.includes('?') ? '&' : '?'}v=${ts}`);
        setSelectedImageFile(`${url}${url.includes('?') ? '&' : '?'}v=${ts}`);
      } else {
        setImagePreview('');
        setSelectedImageFile('');
      }
    } else if (sessionStorage.getItem('Origin') === 'UK') {
      if (data.IDCARDNO && data.IDCARDTYPE) {
        const ts = Date.now();
        const url = `${axios.defaults.ukImageURL}/MT${data.IDCARDNO}-${getIdCardNameById(data.IDCARDTYPE)}.jpg`;
        setImagePreview(`${url}${url.includes('?') ? '&' : '?'}v=${ts}`);
        setSelectedImageFile(`${url}${url.includes('?') ? '&' : '?'}v=${ts}`);
      } else {
        setImagePreview('');
        setSelectedImageFile('');
      }
    } else if (sessionStorage.getItem('Origin') === 'SL') {
      if (data.IDCARDNO && data.IDCARDTYPE) {
        const ts = Date.now();
        const url = `${axios.defaults.slImageURL}/MT${data.IDCARDNO}-${getIdCardNameById(data.IDCARDTYPE)}.jpg`;
        setImagePreview(`${url}${url.includes('?') ? '&' : '?'}v=${ts}`);
        setSelectedImageFile(`${url}${url.includes('?') ? '&' : '?'}v=${ts}`);
      } else {
        setImagePreview('');
        setSelectedImageFile('');
      }
    }
    const countryData = countryList.find((country) => data.COUNTRYID === country.CountryId) || ''
    const mappedValues = {
      fullName: data.CUSTOMERNAME || '',
      dob: moment(data.DOB).format('YYYY-MM-DD'),
      addr1: data.ADDRESS1 || '',
      addr2: data.ADDRESS2 || '',
      addr3: data.ADDRESS3 || '',
      coo: data.Origin || 'IN',
      branch: data.BRNACHID || '',
      tel: data.PHONE || '',
      alterTel: data.ALTERNATIVEPHONE || '',
      mailid: data.EMAILID || '',
      city: data.CITY || '',
      state: selectedState,
      country: countryData || '',
      pincode: data.ZIPCODE || '',
      requested_date: moment(data.SignupRequestDate).format('YYYY-MM-DD'),
      salesPerson: response.data || '',
      remarks: data.REMARKS || '',
      idCardType: data.IDCARDTYPE || '',
      IDcardFile: null,
      IdCardNo: data.IDCARDNO || '',
      WebAccess: data.WebAccess || '',
      LeadStatus: data.LEADSTATUS || '',
      ExpiryDate: moment(data.ExpiryDate).format('YYYYMMDD') || '',
      isActive: data.Active === 'Y',
        referedby: data.Referedby || '',
      referother: data.OtherReferSource || ''
    };
    findTelCode(countryData.CountryName);
    setInitialValue(mappedValues);
    setOpen(true);
  };

  const ValidationSchema = useMemo(
    () =>
      Yup.lazy((values) =>
        Yup.object({
          fullName: Yup.string().min(3, 'First name is too short'),
          dob: Yup.date()
            .nullable()
            .required('Date of birth is required')
            .test('valid-year', 'Year must be realistic (between 1900 and current year)', function (value) {
              if (!value) return false;
              const year = new Date(value).getFullYear();
              const currentYear = new Date().getFullYear();
              return year >= 1900 && year <= currentYear;
            }),
          addr1: Yup.string().required('Address 1 is required'),
          addr2: Yup.string(),
          addr3: Yup.string(),
          city: Yup.string().required('Enter your city'),
          // state: Yup.object().required('Select state'),
          country: Yup.object().required('Select country'),
          pincode: Yup.string()
            .matches(/^[a-zA-Z0-9 ]+$/, 'Pincode can only contain letters and numbers')
            .max(15, 'Pincode cannot exceed 15 characters')
            .required('Pincode is required'),
          alterTel: Yup.string()
            // .required('Alternative Contact number is required')
            .matches(/^\d+$/, 'Alternative Contact number must contain only digits')
            .min(9, 'Alternative Contact number must be at least 9 digits')
            .max(15, 'Alternative Contact number must not exceed 15 digits'),
          tel: Yup.string()
            .required('Contact number is required')
            .matches(/^\d+$/, 'Contact number must contain only digits')
            .min(9, 'Contact number must be at least 9 digits')
            .max(15, 'Contact number must not exceed 15 digits'),
          mailid: Yup.string()
            .email('Invalid email format')
            .max(50, 'Mail ID cannot exceed 50 characters')
            .required('Mail ID is required'),
          coo: Yup.string().required('Country of origin is required'),
          branch: Yup.string().required('Branch is required'),
          remarks: Yup.string().max(100, 'Remarks must not exceed 100 characters'),
          salesPerson: Yup.array().min(1, 'Assign Sales Person for this customer').required(),
          idCardType: values.IDcardFile ? Yup.string().required('select idCardType') : Yup.string(),
          // IdCardNo: values.IDcardFile ? Yup.string().required('IdCardNo is required') : Yup.string(),
          IdCardNo: values.IDcardFile
            ? Yup.string()
              .required('IdCardNo is required')
              .matches(/^[a-zA-Z0-9 ]*$/, 'No special characters allowed') // Allows letters, numbers, and spaces
            : Yup.string().matches(/^[a-zA-Z0-9 ]*$/, 'No special characters allowed'),
          LeadStatus: Yup.string().required('status is required'),
        })
      ),
    [initialValue]
  );

  async function checkInitialCondition(mailid) {
    try {
      const response = await axios.post('login/verifyEmailId', { EmailId: mailid });

      // Assuming the API returns a boolean or a specific value to indicate whether to proceed
      const data = response.data.filter(a => a.WebAccess === 'Y')
      setCustomerEmailidData(data)
      if (data && data.length > 0 && Number(editID) !== Number(data[0].CustomerId)) {
        // Show the popup message
        // openSnackBar('A transaction is found, cannot proceed!', 'error');
        handleOpenCustomerDialog()
        return true; // Indicate that the process should stop
      }
      return false; // Indicate that the process can continue
    } catch (error) {
      // openSnackBar(error.response?.data || 'Failed to check initial condition!', 'error');
      return true; // Stop the process in case of an error
    }
  }

  async function UpdateProfileFromSE(values) {
    let modifiedUrl;
    const originalUrl = selectedImageFile;
    const baseUrl = `${axios.baseURL}TCMSWeb/`;
    if (typeof originalUrl !== 'object') {
      modifiedUrl = originalUrl.replace(baseUrl, '');
    } else {
      modifiedUrl = selectedImageFile;
    }

    // Mapping the data to the backend API input names
    const formData = new FormData();
    formData.append('CustomerId', editID);
    formData.append('CUSTOMERNAME', values.fullName || '');
    formData.append('DOB', moment(values.dob).format('YYYY-MM-DD'));
    formData.append('Phone', values.tel || '');
    formData.append('AlternativePhone', values.alterTel || '');
    formData.append('EMAILID', values.mailid || '');
    formData.append('ADDRESS1', values.addr1 || '');
    formData.append('ADDRESS2', values.addr2 || '');
    formData.append('ADDRESS3', values.addr3 || '');
    formData.append('COUNTRY', values.country.CountryName || '');
    formData.append('STATE', values.state ? values.state.StateName : '');
    formData.append('CUSSTATEID', values.state ? values.state.StateId : 0);
    formData.append('CUSCOUNTRYID', values.country.CountryId || '');
    formData.append('ZIPCODE', values.pincode || '');
    formData.append('CITY', values.city || '');
    formData.append('Remarks', values.remarks || '');
    formData.append('IdCardtype', values.idCardType || 0);
    formData.append('IdCardNo', values.IdCardNo || '');
    formData.append('IdCardName', getIdCardNameById(values.idCardType) || '');
    formData.append('DocImage', modifiedUrl);
    formData.append('LeadStatus', values.LeadStatus || '');
    formData.append('Active', values.isActive ? 'Y' : 'N');
    formData.append('Referedby', values.referedby || 0);
    formData.append('OtherReferSource', values.referother || '');
    const config = {
      headers: {
        Country: sessionStorage.getItem('Origin'),
        'Content-Type': 'multipart/form-data',
      },
    };
    try {
      showLoading();
        const getReferralSourceName = (referralId) => {
          const referral = referedby.find(ref => Number(ref.ReferralSourceId) === Number(referralId));
          return referral ? referral.ReferralSourceName : '';
        };
      
        // Map oldData to match newData structure
                        const oldDataMapped = {
                          CUSTOMERID: oldData.CUSTOMERID || 0,
                          CUSTOMERNAME: oldData.CUSTOMERNAME || '',
                          DOB: oldData.DOB ? moment(oldData.DOB).format('YYYY-MM-DD') : '',
                          Phone: oldData.PHONE || '',
                          AlternativePhone: oldData.ALTERNATIVEPHONE || '',
                          EMAILID: oldData.EMAILID || '',
                          ADDRESS1: oldData.ADDRESS1 || '',
                          ADDRESS2: oldData.ADDRESS2 || '',
                          ADDRESS3: oldData.ADDRESS3 || '',
                          COUNTRY: oldData.COUNTRY || '',
                          STATE: oldData.STATE || '',
                          ZIPCODE: oldData.ZIPCODE || '',
                          CITY: oldData.CITY || '',
                          Remarks: oldData.REMARKS || '',
                          IdCardNo: oldData.IDCARDNO || '',
                          IdCardName: oldData.IDCARDTYPE ? getNameById(oldData.IDCARDTYPE) : '',
                          SignupRequestDate: oldData.SignupRequestDate ? moment(oldData.SignupRequestDate).format('YYYY-MM-DD') : '',
                          Origin: oldData.Origin || '',
                          Referedby: getReferralSourceName(oldData.Referedby),
                          OtherReferSource: oldData.OtherReferSource || ''
                        };
      
                        // Parse newData from formData
                        const {
                          CUSTOMERNAME,
                          DOB,
                          Phone,
                          AlternativePhone,
                          EMAILID,
                          ADDRESS1,
                          ADDRESS2,
                          ADDRESS3,
                          COUNTRY,
                          STATE,
                          ZIPCODE,
                          CITY,
                          Remarks,
                          IdCardNo,
                          IdCardName,
                          SignupRequestDate,
                          Origin,
                          Referedby,
                          OtherReferSource
                        } = Object.fromEntries(formData.entries());
      
                        
                        // Get new referral source name
                        const newReferralName = getReferralSourceName(Referedby);
                        
      
                        const newData = {
                          CUSTOMERNAME,
                          DOB,
                          Phone,
                          AlternativePhone,
                          EMAILID,
                          ADDRESS1,
                          ADDRESS2,
                          ADDRESS3,
                          COUNTRY,
                          STATE,
                          ZIPCODE,
                          CITY,
                          Remarks,
                          IdCardNo,
                          IdCardName,
                          SignupRequestDate,
                          Origin,
                          Referedby: newReferralName, // Use the name instead of ID
                          OtherReferSource,
                        };

      const response= await axios.post('Transactions/SalesControls/UpdateProfileFromSE', formData, config);

      if(response.data.action.rowsAffected.length > 0 
                    || response.data.seinsertResult.rowsAffected.length > 0)
              {
                 await axios.post('notifications/mails/sendLedgerUpdateMail',
                  { Old : oldDataMapped,
                    New : newData
                  }
                )
              }
      await getAllData();
      await GetCustomerHelp();
      setOpen(false);
      openSnackBar('Profile Has Been Updated Successfully !', 'success');
      getAllData();
    } catch (e) {
      openSnackBar('Something Went Wrong try Again !', 'error');
    }
    hideLoading();
  }

  // Reset Follow-up State
  const resetFollowUpState = () => {
    setNewFollowUp({
      followUpDateTime: '',
      remarks: '',
      action: '',
    });
    setIsEditing(false);
    setEditingRowId(null);
    setRowDeleteID(null);
  };

  const [formErrors, setFormErrors] = useState({
    fromDate: '',
    toDate: '',
  });

  const validateFilters = () => {
    const errors = {};
    // Validate fromDate: should not be empty
    if (!fromDate) {
      errors.fromDate = 'From date is required';
    } else if (!moment(fromDate, 'YYYY-MM-DD', true).isValid()) {
      errors.fromDate = 'Invalid date format';
    }

    // Validate toDate: should not be empty and be a valid date
    if (!toDate) {
      errors.toDate = 'To date is required';
    } else if (!moment(toDate, 'YYYY-MM-DD', true).isValid()) {
      errors.toDate = 'Invalid date format';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0; // Return true if no errors
  };

  const [openConfirmDialogDelete, setOpenConfirmDialogDelete] = useState(false);

  const handleOpenConfirmDialogDelete = () => {
    setOpenConfirmDialogDelete(true);
  };

  const handleCloseConfirmDialogDelete = () => {
    setOpenConfirmDialogDelete(false);
  };

  const [openDialogPreview, setOpenDialogPreview] = useState(false);

  const handleOpenDialogPreview = () => {
    setOpenDialogPreview(true);
  };

  const handleCloseDialogPreview = () => {
    setOpenDialogPreview(false);
  };

  const [openCustomerDialog, setOpenCustomerDialog] = useState(false);

  const handleOpenCustomerDialog = () => {
    setOpenCustomerDialog(true);
  };

  const handleCloseCustomerDialog = () => {
    setOpenCustomerDialog(false);
  };

  const handleReviewButtonClick = () => {
    setDialogOpenState(true);
  };

  const closeDialog = () => {
    setDialogOpenState(false);
  };

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2 }} elevation={3}>
        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2}>
          <Typography
            variant="h5"
            p={0.5}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={12}
            pl={2}
            color="white"
            sx={{
              background: '#8ABFA3',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Ledger FollowUps
            </Typography>
          </Typography>
        </Grid>

        <Grid container spacing={2} p={1} my={0.5} rowSpacing={2} columnSpacing={1}>
          <Grid item md={3} xs={12}>
            {/* Status Filter */}
            <TextField
              fullWidth
              select
              label="Status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              variant="outlined"
              size="small"
            >
              {statusOptions.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item md={3} xs={12}>
            {/* Search Type Selector */}
            <TextField
              fullWidth
              select
              label="Search By"
              value={searchType}
              onChange={(e) => {
                setSearchType(e.target.value);
                setSearchValue('');
                setAutoCompleteOptions([]);
              }}
              variant="outlined"
              size="small"
            >
              <MenuItem value="name">Customer Name</MenuItem>
              <MenuItem value="phone">Phone Number</MenuItem>
            </TextField>
          </Grid>
          <Grid item md={6} xs={12}>
            {/* Autocomplete for Search Input */}
            <Autocomplete
              value={searchValue}
              // freeSolo
              options={autoCompleteOptions.filter((option) =>
                option.details ? option.details.toLowerCase().startsWith(searchValue.toLowerCase()) : false
              )}
              getOptionLabel={(option) => (typeof option === 'string' ? option : option.details)} // Ensure it displays details
              onInputChange={(event, value) => {
                setSearchValue(value);
                fetchAutoCompleteOptions(value);
              }}
              onChange={(event, newValue) => {
                if (newValue) {
                  setSearchValue(newValue.label);
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={`Search by ${searchType === 'name' ? 'Name' : 'Phone'}`}
                  variant="outlined"
                  size="small"
                />
              )}
            />
          </Grid>
          <Grid item md={4} xs={12}>
            {/* Filter by Date Type */}
            <TextField
              fullWidth
              select
              label="Filter By Date"
              value={dateFilterType}
              onChange={(e) => setDateFilterType(e.target.value)}
              variant="outlined"
              size="small"
            >
              <MenuItem value="R">Requested Date</MenuItem>
              <MenuItem value="A">Assigned Date</MenuItem>
            </TextField>
          </Grid>
          <Grid item md={2} xs={12}>
            {/* From Date */}
            <TextField
              fullWidth
              label="From Date"
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              inputProps={{ max: '9999-12-31' }}
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              size="small"
              name="fromDate"
              error={!!formErrors.fromDate}
              helperText={formErrors.fromDate}

            />
          </Grid>
          <Grid item md={2} xs={12}>
            {/* To Date */}
            <TextField
              fullWidth
              label="To Date"
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              size="small"
              error={!!formErrors.toDate}
              helperText={formErrors.toDate}
              name="toDate"
              inputProps={{ max: '9999-12-31' }}
            />
          </Grid>
          <Grid item md={1} xs={12}>
            {/* View Button */}
            <Button variant="contained" color="primary" onClick={getAllData} fullWidth>
              View
            </Button>
          </Grid>
          <Grid item md={1} xs={12}>
            <Button
              variant="contained"
              style={{ color: 'white', backgroundColor: '#118a27' }}
              onClick={GetExcel}
              fullWidth
            >
              Excel
            </Button>
          </Grid>
          <Grid item md={2} xs={12}>
            {/* Add Ledger Button */}
            <Button variant="contained" color="warning" onClick={handleReviewButtonClick} fullWidth>
              Add Ledger
            </Button>
          </Grid>
        </Grid>
        {getDataForView.length > 0 ? (
          <>
            <TableContainer component={Paper} elevation={2} sx={{ bgcolor: 'inherit', maxHeight: 600 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">S.No</StyledTableCell>
                    <StyledTableCell align="left">Ledger Details</StyledTableCell>
                    <StyledTableCell align="center">Requested On</StyledTableCell>
                    <StyledTableCell align="center">Approved By / On</StyledTableCell>
                    <StyledTableCell align="center">Assigned On</StyledTableCell>
                    <StyledTableCell align="center">Actions</StyledTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {(rowsPerPage > 0
                    ? getDataForView.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    : getDataForView
                  ).map((data, i) => (
                    <>
                      <TableRow key={data.CUSTOMERID} hover>
                        <TableCell align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                        <TableCell align="left" sx={{ whiteSpace: 'nowrap' }}>
                          <Stack spacing={1} py={1}>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <PersonPinIcon fontSize="x-small" color="primary" />
                              <Typography variant="subtitle2" color="#243642" pr={1}>
                                {data.CUSTOMERNAME || '-'}{' '}
                                {data.LEADSTATUS === 'H' ? (
                                  <Chip size="small" color="error" label="Hot 🔥" />
                                ) : data.LEADSTATUS === 'W' ? (
                                  <Chip label="Warm ☀️" size="small" color="warning" />
                                ) : data.LEADSTATUS === 'C' ? (
                                  <Chip label="Cold ❄️" size="small" color="info" />
                                ) : (
                                  ''
                                )}
                              </Typography>{' '}
                            </Stack>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <LocationOn fontSize="x-small" color="error" />
                              <Typography variant="body2">
                                {[data.ADDRESS1, data.ADDRESS2, data.ADDRESS3].filter(Boolean).join(', ') || '-'} <br />
                                {[data.CITY, data.STATE, data.ZIPCODE, data.COUNTRY].filter(Boolean).join(', ') || '-'}
                              </Typography>
                            </Stack>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <Phone fontSize="x-small" color="success" />
                              <Typography variant="body2" mr={2} pr={1}>
                                {data.PHONE || '-'}
                              </Typography>{' '}
                              | <Email fontSize="x-small" color="error" />
                              <Typography variant="body2" pr={1} sx={{ textTransform: 'lowercase' }}>
                                {data.EMAILID || '-'}
                              </Typography>
                              |{' '}
                              <Typography variant="body2" pr={1}>
                                Dob : {data.DOB ? moment(data.DOB).format('DD-MM-YYYY') : '-'}
                              </Typography>
                            </Stack>{' '}
                          </Stack>
                        </TableCell>
                        <TableCell align="center">
                          {data.SignupRequestDate ? moment.utc(data.SignupRequestDate).format('DD-MM-YYYY') : '-'}
                        </TableCell>
                        <TableCell align="center">
                          {data.ApprovedBy
                            ? `${data.ApprovedBy} / ${moment(data.Approvedon).format('DD-MM-YYYY')}`
                            : '-'}
                        </TableCell>
                        <TableCell align="center">
                          {data.AssignedOn ? moment(data.AssignedOn).local().format('DD-MM-YYYY hh:mm:ss A') : '-'}
                        </TableCell>
                        <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                          <Stack direction="column" spacing={1} justifyContent="center" alignItems="center">
                            <Button
                              variant="outlined"
                              color="primary"
                              sx={{ boxShadow: 1 }}
                              onClick={() => handleReviewClick(data)}
                              size="small"
                              fullWidth
                              startIcon={<AccountCircleIcon fontSize="small" />}
                            >
                              Profile
                            </Button>
                            <Button
                              variant="contained"
                              color="info"
                              sx={{ boxShadow: 1, whiteSpace: 'nowrap' }} // Corrected whiteSpace
                              onClick={() => handleFollowUpTableToggle(i, data)}
                              size="small"
                              fullWidth
                              startIcon={<EventRepeatIcon fontSize="small" />}
                            >
                              Follow-ups
                            </Button>
                          </Stack>
                        </TableCell>
                      </TableRow>
                    </>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={currentPage}
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
              }}
              mt={2}
            />
          </>
        ) : (
          <NoResultsFound />
        )}
        <Grid m={2}>
          <Dialog
            open={open}
            onClose={() => {
              setOpen(!open);
              setInitialValue({ color: '' });
            }}
            maxWidth={'xl'}
            fullScreen
          >
            <Container component={Paper} elevation={2}>
              <Divider sx={{ my: 2 }} variant="middle">
                <Chip label="Ledger Profile Review" size="small" color="primary" />
              </Divider>
              <Stack sx={{ p: 2 }}>
                <Paper>
                  <Formik
                    validationSchema={ValidationSchema}
                    initialValues={initialValue}
                    onSubmit={async (values, { resetForm }) => {
                      const shouldExit = await checkInitialCondition(values.mailid);
                      if (shouldExit) {
                        return;
                      }
                      await UpdateProfileFromSE({ ...initialValue, ...values });
                      resetForm();
                      setTelCode('  ');
                    }}
                  >
                    {({
                      submitForm,
                      touched,
                      values,
                      errors,
                      handleChange,
                      handleBlur,
                      isSubmitting,
                      setFieldTouched,
                      validateForm,
                      setFieldValue,
                    }) => (
                      <Form>
                        <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                          <Grid item xs={12}>
                            <Stack justifyContent={'end'} alignItems={'end'}>
                              <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      size='small'
                                      color='success'
                                      checked={values.isActive}
                                      mt={2}
                                      onChange={(event) => {
                                        setFieldValue("isActive", event.target.checked) // Update Formik state
                                      }}
                                    />} label="Active" />
                              </FormGroup>
                            </Stack>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <TextField
                              fullWidth
                              size="small"
                              label="Name"
                              type="text"
                              name="fullName"
                              onBlur={handleBlur}
                              error={touched.fullName && !!errors.fullName}
                              helperText={touched.fullName && errors.fullName ? errors.fullName : ''}
                              value={values.fullName}
                              onChange={handleChange}
                              required
                            />
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <TextField
                              fullWidth
                              size="small"
                              label="Date Of Birth"
                              type="date"
                              name="dob"
                              InputLabelProps={{ shrink: true }}
                              onBlur={handleBlur}
                              error={touched.dob && !!errors.dob}
                              helperText={touched.dob && errors.dob ? errors.dob : ''}
                              value={values.dob}
                              onChange={handleChange}
                              inputProps={{ max: '9999-12-31' }}
                              required
                            />
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <TextField
                              fullWidth
                              size="small"
                              label="Requested Date"
                              type="date"
                              name="requested_date"
                              disabled
                              InputLabelProps={{ shrink: true }}
                              onBlur={handleBlur}
                              error={touched.requested_date && !!errors.requested_date}
                              helperText={touched.requested_date && errors.requested_date ? errors.requested_date : ''}
                              value={values.requested_date}
                              onChange={handleChange}
                              inputProps={{ max: '9999-12-31' }}
                            />
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <TextField
                              multiline
                              rows={3}
                              fullWidth
                              size="small"
                              label="Address 1"
                              name="addr1"
                              onBlur={handleBlur}
                              error={touched.addr1 && !!errors.addr1}
                              helperText={touched.addr1 && errors.addr1 ? errors.addr1 : ''}
                              value={values.addr1}
                              onChange={handleChange}
                              required
                            />
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <TextField
                              multiline
                              rows={3}
                              fullWidth
                              size="small"
                              label="Address 2"
                              name="addr2"
                              onBlur={handleBlur}
                              error={touched.addr2 && !!errors.addr2}
                              helperText={touched.addr2 && errors.addr2 ? errors.addr2 : ''}
                              value={values.addr2}
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <TextField
                              multiline
                              rows={3}
                              fullWidth
                              size="small"
                              label="Address 3"
                              name="addr3"
                              onBlur={handleBlur}
                              error={touched.addr3 && !!errors.addr3}
                              helperText={touched.addr3 && errors.addr3 ? errors.addr3 : ''}
                              value={values.addr3}
                              onChange={handleChange}
                            />
                          </Grid>
                          <Grid item md={2} xs={12}>
                            <FormControl fullWidth size="small" fullwidth required>
                              <InputLabel id="Country-select-label">Country of Origin</InputLabel>
                              <Select
                                fullWidth
                                labelId="Country-select-label"
                                value={values.coo}
                                size="small"
                                name="coo"
                                label="Country of Origin"
                                onChange={(e) => {
                                  handleChange(e);
                                  GetBranchList(e.target.value);
                                  GetSalesExecutives(e.target.value);
                                }}
                                error={touched.coo && !!errors.coo}
                                disabled
                              >
                                {Object.entries(Countrys).map(([fullName, code]) => (
                                  <MenuItem key={code} value={code}>
                                    {fullName}
                                  </MenuItem>
                                ))}
                              </Select>
                              {touched.coo && errors.coo && (
                                <Grid item xs={12}>
                                  <Typography
                                    variant="caption"
                                    color="error"
                                    className="shake-helper-text"
                                    margin="0 0 0 14px"
                                  >
                                    {errors.coo}
                                  </Typography>
                                </Grid>
                              )}
                            </FormControl>
                          </Grid>
                          <Grid item md={2} xs={12}>
                            <Autocomplete
                              options={countryList}
                              getOptionLabel={(country) => country.CountryName}
                              renderOption={(props, country) => (
                                <li {...props} key={country.Countryid}>
                                  {country.CountryName}
                                </li>
                              )}
                              isOptionEqualToValue={(country) => country.CountryId === values.country.CountryId}
                              value={values.country || null}
                              name="country"
                              onChange={(event, value) => {
                                handleCountryChange(value);
                                setFieldValue('country', value);
                                setFieldValue('state', null);
                              }}
                              size="small"
                              onBlur={() => {
                                setFieldTouched('country', true);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Residing Country"
                                  error={touched.country && !!errors.country}
                                  helperText={touched.country && errors.country}
                                  required
                                />
                              )}
                            />
                          </Grid>
                          <Grid item md={2} xs={12}>
                            <Autocomplete
                              options={stateList}
                              getOptionLabel={(state) => state.StateName}
                              renderOption={(props, state) => (
                                <li {...props} key={state.Stateid}>
                                  {state.StateName}
                                </li>
                              )}
                              isOptionEqualToValue={(option, value) => option.StateId === value.StateId}
                              value={values.state || null}
                              name="state"
                              onChange={(event, value) => {
                                setFieldValue('state', value);
                              }}
                              size="small"
                              onBlur={() => {
                                setFieldTouched('state', true);
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Province/State"
                                // error={touched.state && !!errors.state}
                                // helperText={touched.state && errors.state}
                                />
                              )}
                            />
                          </Grid>
                          <Grid item md={2} xs={12}>
                            <TextField
                              fullWidth
                              size="small"
                              label="City"
                              type="text"
                              name="city"
                              onBlur={handleBlur}
                              error={touched.city && !!errors.city}
                              helperText={touched.city && errors.city ? errors.city : ''}
                              value={values.city}
                              onChange={handleChange}
                              required
                            />
                          </Grid>
                          <Grid item md={2} xs={12}>
                            <TextField
                              fullWidth
                              size="small"
                              label="Postal Code"
                              type="text"
                              name="pincode"
                              onBlur={handleBlur}
                              error={touched.pincode && !!errors.pincode}
                              helperText={touched.pincode && errors.pincode ? errors.pincode : ''}
                              value={values.pincode}
                              onChange={handleChange}
                              required
                            />
                          </Grid>
                          <Grid item md={2} xs={12}>
                            {/* <TextField
                              fullWidth
                              size="small"
                              label="Contact No"
                              type="text"
                              name="tel"
                              onBlur={handleBlur}
                              error={touched.tel && !!errors.tel}
                              helperText={touched.tel && errors.tel ? errors.tel : ''}
                              value={values.tel}
                              onChange={(e) => {
                                const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                handleChange({ target: { name: 'tel', value: numericValue } }); // Manually trigger Formik's handleChange
                              }}
                              required
                            // onChange={handleChange}
                            /> */}
                            <FormControl fullWidth size="small" required>
                              <InputLabel htmlFor="outlined-adornment-tel">Contact No</InputLabel>
                              <OutlinedInput
                                id="outlined-adornment-tel"
                                type="text"
                                name="tel"
                                value={values.tel}
                                onChange={(e) => {
                                  const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                  handleChange({ target: { name: 'tel', value: numericValue } }); // Manually trigger Formik's handleChange
                                }}
                                // onChange={handleChange}
                                onBlur={handleBlur}
                                label="Contact No"
                                error={touched.tel && !!errors.tel}
                                required
                                startAdornment={
                                  <InputAdornment position="start">
                                    {telCode}
                                  </InputAdornment>
                                } // Optional prefix
                              />
                              {touched.tel && errors.tel && (
                                <Typography variant="caption" color="error">
                                  {errors.tel}
                                </Typography>
                              )}
                            </FormControl>
                          </Grid>
                          <Grid item md={2} xs={12}>
                            {/* <TextField
                              fullWidth
                              size="small"
                              label="Alternative  No"
                              type="number"
                              name="alterTel"
                              onBlur={handleBlur}
                              error={touched.alterTel && !!errors.alterTel}
                              helperText={touched.alterTel && errors.alterTel ? errors.alterTel : ''}
                              value={values.alterTel}
                              // onChange={handleChange}
                              onChange={(e) => {
                                const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                handleChange({ target: { name: 'alterTel', value: numericValue } }); // Manually trigger Formik's handleChange
                              }}
                            /> */}
                            <FormControl fullWidth size="small" required>
                              <InputLabel htmlFor="outlined-adornment-tel">Alternative  No</InputLabel>
                              <OutlinedInput
                                id="outlined-adornment-tel"
                                type="text"
                                name="alterTel"
                                value={values.alterTel}
                                onChange={(e) => {
                                  const numericValue = e.target.value.replace(/[^0-9]/g, '');
                                  handleChange({ target: { name: 'alterTel', value: numericValue } }); // Manually trigger Formik's handleChange
                                }}
                                // onChange={handleChange}
                                onBlur={handleBlur}
                                label="Alternative  No"
                                error={touched.alterTel && !!errors.alterTel}
                                required
                                startAdornment={
                                  <InputAdornment position="start">
                                    {telCode}
                                  </InputAdornment>
                                } // Optional prefix
                              />
                              {touched.alterTel && errors.alterTel && (
                                <Typography variant="caption" color="error">
                                  {errors.alterTel}
                                </Typography>
                              )}
                            </FormControl>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <TextField
                              fullWidth
                              size="small"
                              label="Email"
                              type="email"
                              name="mailid"
                              onBlur={handleBlur}
                              error={touched.mailid && !!errors.mailid}
                              helperText={touched.mailid && errors.mailid ? errors.mailid : ''}
                              value={values.mailid}
                              onChange={handleChange}
                              required
                            />
                          </Grid>
                          <Grid item md={2} xs={12}>
                            <FormControl fullWidth size="small" required>
                              <InputLabel>Branch</InputLabel>
                              <Select
                                value={values.branch || ''}
                                name="branch"
                                size="small"
                                label="Branch"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.branch && !!errors.branch}
                                disabled
                              >
                                {branchList.length > 0 ? (
                                  branchList.map((branch) => (
                                    <MenuItem key={branch.BranchId} value={branch.BranchId}>
                                      {branch.BranchName}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem disabled>No branches available</MenuItem>
                                )}
                              </Select>
                              {touched.branch && errors.branch && (
                                <Typography
                                  variant="caption"
                                  color="error"
                                  className="shake-helper-text"
                                  margin="4px 0 0 14px"
                                >
                                  {errors.branch}
                                </Typography>
                              )}
                            </FormControl>
                          </Grid>
                          <Grid item md={2} xs={12}>
                            <FormControl fullWidth size="small">
                              <InputLabel>ID Card Type</InputLabel>
                              <Select
                                value={values.idCardType || ''}
                                name="idCardType"
                                size="small"
                                label="ID Card Type"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.idCardType && !!errors.idCardType}
                              >
                                {idCardTypes.length > 0 ? (
                                  idCardTypes.map((idCard) => (
                                    <MenuItem key={idCard.id} value={idCard.id}>
                                      {idCard.name}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem disabled>No ID card types available</MenuItem>
                                )}
                              </Select>
                              {touched.idCardType && errors.idCardType && (
                                <Typography variant="caption" color="error" margin="4px 0 0 14px">
                                  {errors.idCardType}
                                </Typography>
                              )}
                            </FormControl>
                          </Grid>
                          <Grid item md={2} xs={12}>
                            <TextField
                              fullWidth
                              size="small"
                              label="ID Card No"
                              type="text"
                              name="IdCardNo"
                              onBlur={handleBlur}
                              error={touched.IdCardNo && !!errors.IdCardNo}
                              helperText={touched.IdCardNo && errors.IdCardNo ? errors.IdCardNo : ''}
                              value={values.IdCardNo}
                              onChange={handleChange}
                              
                            />
                          </Grid>
                          <Grid item md={8} xs={12}>
                            <Autocomplete
                              multiple
                              id="salesperson-select"
                              options={salesPersons}
                              getOptionLabel={(option) => option.salesPersonName}
                              disableCloseOnSelect
                              value={values.salesPerson}
                              onBlur={handleBlur}
                              onChange={(event, newValue) => {
                                setFieldValue('salesPerson', newValue);
                              }}
                              disabled
                              renderOption={(props, option, { selected }) => (
                                <li {...props}>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                    size="small"
                                  />
                                  {option.salesPersonName}
                                </li>
                              )}
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                    key={index}
                                    label={option.salesPersonName}
                                    {...getTagProps({ index })}
                                    size="small" // Control the size of the chip
                                    color="primary"
                                    variant="outlined"
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  label="Sales Persons"
                                  error={!!errors.salesPerson && touched.salesPerson}
                                  required
                                />
                              )}
                              style={{ width: '100%' }}
                            />
                            {touched.salesPerson && errors.salesPerson && (
                              <Typography variant="caption" color="error" margin="4px 0 0 14px">
                                {errors.salesPerson}
                              </Typography>
                            )}
                          </Grid>
                          <Grid item md={4} xs={12} justifyContent="center">
                            <Stack
                              direction="row"
                              spacing={1}
                              justifyContent="center"
                              alignItems="center"
                              sx={{ width: '100%' }}
                            >
                              <FormControl fullWidth size="small" required>
                                <InputLabel shrink id="statusLabel">
                                  Status
                                </InputLabel>
                                <div className="radio-input">
                                  <label>
                                    <input
                                      type="radio"
                                      id="hot"
                                      name="LeadStatus"
                                      value="H"
                                      checked={values.LeadStatus === 'H'}
                                      onChange={handleChange}
                                    />
                                    <span style={{ marginRight: '4px' }}>Hot </span>🔥
                                  </label>
                                  <label>
                                    <input
                                      type="radio"
                                      id="cold"
                                      name="LeadStatus"
                                      value="C"
                                      checked={values.LeadStatus === 'C'}
                                      onChange={handleChange}
                                    />
                                    <span style={{ marginRight: '4px' }}>Cold</span> ❄️
                                  </label>
                                  <label>
                                    <input
                                      type="radio"
                                      id="warm"
                                      name="LeadStatus"
                                      value="W"
                                      checked={values.LeadStatus === 'W'}
                                      onChange={handleChange}
                                    />
                                    <span style={{ marginRight: '4px' }}>Warm</span>☀️
                                  </label>
                                  <span className="selection" data-value={values.LeadStatus} />
                                </div>
                                {touched.LeadStatus && errors.LeadStatus && (
                                  <Typography
                                    variant="caption"
                                    color="error"
                                    className="shake-helper-text"
                                    margin="4px 0 0 14px"
                                  >
                                    {errors.LeadStatus}
                                  </Typography>
                                )}
                              </FormControl>
                            </Stack>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <Stack direction={'column'} spacing={2}>
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={1}
                                border={1}
                                borderRadius={1}
                                borderColor="#e0e0e0"
                                p={1}
                                justifyContent="center"
                              >
                                <Stack direction="row" alignItems="center" justifyContent={'center'} spacing={1}>
                                  <Box>
                                    <label htmlFor="fileInput">
                                      <img
                                        src={
                                          selectedImageFile ===
                                            `${sessionStorage.getItem('Origin') === 'IN'
                                              ? axios.defaults.inImageURL
                                              : sessionStorage.getItem('Origin') === 'UK'
                                                ? axios.defaults.ukImageURL
                                                : axios.defaults.slImageURL
                                            }`
                                            ? NoimageFound
                                            : selectedImageFile === null ||
                                              selectedImageFile === '' ||
                                              !selectedImageFile
                                              ? imagepreview
                                              : imagePreview
                                        }
                                        alt="imgfor"
                                        className={classes.chooseFileButton}
                                        style={{
                                          maxWidth: '200px',
                                          minWidth: '200px',
                                          maxHeight: '92px',
                                          minHeight: '92px',
                                          objectFit: 'contain',
                                        }}
                                      />
                                      <input
                                        className={classes.fileInput}
                                        id="fileInput"
                                        type="file"
                                        accept="image/jpeg"
                                        name="IDcardFile"
                                        onChange={(event) => {
                                          handleFileChange(event, 'photo');
                                          handleChange(event);
                                        }}
                                        style={{ display: 'none' }}
                                      />
                                      {(selectedImageFile || !NoimageFound) && (
                                        <Button
                                          onClick={handleOpenDialogPreview}
                                          variant="contained"
                                          color="primary"
                                          size="small"
                                          fullWidth
                                          sx={{ boxShadow: 1 }}
                                          mt={2}
                                        >
                                          Preview
                                        </Button>
                                      )}
                                    </label>
                                  </Box>
                                </Stack>
                              </Stack>
                            </Stack>
                          </Grid>
                          <Grid item md={9} xs={12}>
                            <TextField
                              fullWidth
                              size="small"
                              label="Remarks"
                              type="text"
                              multiline
                              rows={5}
                              name="remarks"
                              onBlur={handleBlur}
                              error={touched.remarks && !!errors.remarks}
                              helperText={touched.remarks && errors.remarks ? errors.remarks : ''}
                              value={values.remarks}
                              onChange={handleChange}
                            />
                          </Grid>
                             <Grid item md={3} xs={12}>
                            <FormControl fullWidth size="small" >
                              <InputLabel>Referred By </InputLabel>
                              <Select
                                value={values.referedby || ''}
                                name="referedby"
                                size="small"
                                label="Referred By"
                                onChange={(e) => {
                                  handleChange(e);
                                  setFieldValue('referother', '');
                                }}
                                onBlur={handleBlur}
                                error={touched.referedby && !!errors.referedby}
                              >
                                {referedby.length > 0 ? (
                                  referedby.map((refer) => (
                                    <MenuItem key={refer.ReferralSourceId} value={refer.ReferralSourceId}>
                                      {refer.ReferralSourceName}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem disabled>Not available</MenuItem>
                                )}
                              </Select>
                              
                            </FormControl>
                          </Grid>
                           <Grid item md={3} xs={12}>
                              <TextField
                                fullWidth
                                size="small"
                                label="Other Referral Source"
                                type="text"
                                name="referother"
                                inputProps={{ maxLength: 50 }}
                                onBlur={handleBlur}
                                disabled={!referedby.some(ref => ref.ReferralSourceId === values.referedby && ref.ReferralSourceName?.toLowerCase().includes('other'))}
                                error={touched.referother && !!errors.referother}
                                helperText={touched.referother && errors.referother ? errors.referother : ''}
                                value={values.referother || ''}
                                onChange={handleChange}
                              />
                            </Grid>
                        </Grid>

                        <Stack direction="row" justifyContent="center" gap={2} sx={{ textAlign: 'center', mt: 3 }}>
                          <Button
                            onClick={() => {
                              setOpen(!open);
                              setEditID('');

                              setImagePreview('');
                              setInitialValue({ ...resetStates });
                              setStateList([]);
                            }}
                            variant="contained"
                            color="warning"
                            size="small"
                            sx={{ boxShadow: 1 }}
                          >
                            Close
                          </Button>
                          {values.ExpiryDate === '19000101' && (
                            <Button
                              onClick={submitForm}
                              disabled={isSubmitting}
                              variant="contained"
                              color="primary"
                              size="small"
                              sx={{ boxShadow: 1 }}
                            >
                              Save
                            </Button>
                          )}
                        </Stack>
                        <Dialog open={openDialogPreview} onClose={handleCloseDialogPreview} maxWidth="md">
                          <DialogTitle>Image Preview</DialogTitle>
                          <DialogContent>
                            <img
                              src={
                                selectedImageFile ===
                                  `${sessionStorage.getItem('Origin') === 'IN'
                                    ? axios.defaults.inImageURL
                                    : sessionStorage.getItem('Origin') === 'UK'
                                                ? axios.defaults.ukImageURL
                                                : axios.defaults.slImageURL
                                  }`
                                  ? NoimageFound
                                  : selectedImageFile === null || selectedImageFile === '' || !selectedImageFile
                                    ? imagepreview
                                    : imagePreview
                              }
                              alt="Preview"
                              style={{
                                maxWidth: '100%',
                                maxHeight: '400px',
                                objectFit: 'contain',
                              }}
                            />
                          </DialogContent>
                          <DialogActions>
                            <Stack direction="row" spacing={1} justifyContent="space-between" alignItems="center">
                              <Button
                                onClick={handleOpenConfirmDialogDelete}
                                color="error"
                                variant="outlined"
                                size="small"
                              >
                                Delete
                              </Button>
                              <Button
                                onClick={handleCloseDialogPreview}
                                color="primary"
                                startIcon={<CloseIcon />}
                                variant="contained"
                                size="small"
                              >
                                Close
                              </Button>
                            </Stack>
                          </DialogActions>
                        </Dialog>
                        <Dialog open={openConfirmDialogDelete} onClose={handleCloseConfirmDialogDelete}>
                          <DialogTitle>Confirm Deletion</DialogTitle>
                          <DialogContent>
                            <Typography>Are you sure you want to delete this image?</Typography>
                          </DialogContent>
                          <DialogActions>
                            <Button onClick={handleCloseConfirmDialogDelete} color="primary">
                              Cancel
                            </Button>
                            <Button
                              onClick={() => {
                                setSelectedImageFile(null);
                                setOpenDialogPreview(false);
                                setFieldValue('IdCardNo', '');
                                handleCloseDialogPreview();
                                handleCloseConfirmDialogDelete();
                              }}
                              color="error"
                            >
                              Delete
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </Form>
                    )}
                  </Formik>
                </Paper>
              </Stack>
            </Container>
          </Dialog>
        </Grid>
        {/* Dialog for Adding New Follow-up */}
        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle>{isEditing ? 'Edit Follow-up' : 'Add Follow-up'}</DialogTitle>
          <DialogContent>
            <Stack sx={{ width: '100%' }} mt={2} fullWidth>
              {/* Follow-up Date and Time Input */}
              <TextField
                size="small"
                fullWidth
                label="Follow-up Date and Time"
                type="datetime-local"
                value={newFollowUp.followUpDateTime}
                onChange={handleFollowUpDateTimeChange}
                error={fieldErrors.followUpDateTime}
                helperText={fieldErrors.followUpDateTime ? 'Follow-up date and time must be in the future' : ''}
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{ max: '9999-12-31' }}
              />

              {/* Remarks Input */}
              <TextField
                label="Remarks"
                name="remarks"
                fullWidth
                margin="dense"
                multiline
                rows={3}
                value={newFollowUp.remarks}
                onChange={handleFollowUpChange}
                inputProps={{ maxLength: 100 }}
              />
            </Stack>
          </DialogContent>

          {/* Dialog Actions */}
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              Cancel
            </Button>
            <Button
              onClick={InsertCustomerTimeLine}
              color="primary"
              disabled={!newFollowUp.followUpDateTime || !newFollowUp.remarks.trim() || fieldErrors.followUpDateTime}
            >
              {isEditing ? 'Save Changes' : 'Add'}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Dialog for follow-up table */}
        <Dialog open={openFollowUpTable} maxWidth={'xl'} fullScreen={smallScreens} fullWidth>
          <DialogContent>
            <Divider sx={{ mt: 2 }}>
              <Chip
                label={`Follow-ups for ${ledgerDetails?.CUSTOMERNAME}`}
                size="small"
                color="primary"
                variant="outlined"
              />
            </Divider>
            <Grid container spacing={2} mb={1}>
              {!smallScreens && (
                <Grid item md={9} xs={12}>
                  <Stack spacing={1}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <PortraitIcon fontSize="x-small" color="primary" />
                      <Typography variant="subtitle2" color="#243642" pr={1}>
                        {ledgerDetails?.CUSTOMERNAME || '-'}{' '}
                        {ledgerDetails?.LEADSTATUS === 'H' ? (
                          <Chip size="small" color="error" label="Hot 🔥" />
                        ) : ledgerDetails?.LEADSTATUS === 'W' ? (
                          <Chip label="Warm ☀️" size="small" color="warning" />
                        ) : ledgerDetails?.LEADSTATUS === 'C' ? (
                          <Chip label="Cold ❄️" size="small" color="info" />
                        ) : (
                          <Chip label="-" size="small" />
                        )}
                      </Typography>{' '}
                    </Stack>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <LocationOn fontSize="x-small" color="error" />
                      <Typography variant="body2">
                        {[
                          ledgerDetails?.ADDRESS1,
                          ledgerDetails?.ADDRESS2,
                          ledgerDetails?.ADDRESS3,
                          ledgerDetails?.CITY,
                          ledgerDetails?.STATE,
                          ledgerDetails?.ZIPCODE,
                          ledgerDetails?.COUNTRY,
                        ]
                          .filter(Boolean)
                          .join(', ') || '-'}
                      </Typography>
                    </Stack>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Phone fontSize="x-small" color="success" />
                      <Typography variant="body2" mr={2} pr={1}>
                        {ledgerDetails?.PHONE || '-'}
                      </Typography>{' '}
                      | <Email fontSize="x-small" color="error" />
                      <Typography variant="body2" pr={1} sx={{ textTransform: 'lowercase' }}>
                        {ledgerDetails?.EMAILID || '-'}
                      </Typography>
                      |{' '}
                      <Typography variant="body2" pr={1}>
                        Dob : {ledgerDetails?.DOB ? moment(ledgerDetails?.DOB).format('DD-MM-YYYY') : '-'}
                      </Typography>
                    </Stack>{' '}
                  </Stack>
                </Grid>
              )}
              <Grid item md={3} xs={12}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', my: 1 }}>
                  {moment(ledgerDetails?.ExpiryDate).format('YYYYMMDD') === '19000101' && (
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => handleOpenDialog(ledgerDetails?.CUSTOMERID)}
                      size="small"
                    >
                      Add Follow-up
                    </Button>
                  )}
                </Box>
              </Grid>
            </Grid>
            <TableContainer component={Paper} elevation={2} sx={{ bgcolor: 'inherit' }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <StyledTableCell2 align="center">S.No</StyledTableCell2>
                    <StyledTableCell2 align="center">Follow-up Date & Time </StyledTableCell2>
                    <StyledTableCell2 align="left">Remarks</StyledTableCell2>
                    <StyledTableCell2 align="center">Created Date & Time </StyledTableCell2>
                    <StyledTableCell2 align="center">Created By</StyledTableCell2>
                    {/* <StyledTableCell2 align="center">Actions</StyledTableCell2> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {oneCustomerFollowUps.map((followUp, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{index + 1}</TableCell>
                      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                        {moment.utc(followUp.followupDate).format('LLL')}
                      </TableCell>
                      <TableCell align="left">{followUp.remarks}</TableCell>
                      <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                        {moment(followUp.createdOn).format('LLL')}
                      </TableCell>
                      <TableCell align="center">{followUp.CreatedUser}</TableCell>
                      {/* <TableCell align="center" sx={{ padding: '0' }}>
                        <IconButton aria-label="Edit" onClick={() => handleEditFollowUp(followUp)}>
                          <EditIcon color="primary" />
                        </IconButton>
                        <IconButton aria-label="Delete" onClick={() => handleOpenConfirmDialog(followUp.timelineId)}>
                          <DeleteForeverIcon color="error" />
                        </IconButton>
                      </TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Stack direction="row" spacing={1} justifyContent="center" alignItems="center" mt={2}>
              <Button
                onClick={() => {
                  setOpenFollowUpTable(null);
                  setOneCustomerFollowUps([]);
                }}
                color="warning"
                variant="contained"
                size="small"
              >
                Close
              </Button>
            </Stack>
          </DialogContent>
        </Dialog>

        {/* Confirmation Dialog for Deletion */}
        <Dialog open={openConfirmDialog} onClose={handleCloseConfirmDialog}>
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <Typography>Are you sure you want to delete this Record?</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseConfirmDialog} color="warning">
              Cancel
            </Button>
            <Button onClick={handleConfirmDelete} color="error">
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={openCustomerDialog} onClose={handleCloseCustomerDialog} maxWidth="md">
          <DialogTitle style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <ErrorOutlineIcon color="error" /> This Email Id already exist.
          </DialogTitle>
          <DialogContent>
            {/* Table to display CustomerName, EmailId, and Status */}
            <Table size="small" aria-label="Customer Details">
              <TableHead>
                <TableRow>
                  <TableCell>Customer Name</TableCell>
                  <TableCell>Email ID</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {customerEmailidData.map((customer, index) => (
                  <TableRow key={index}>
                    <TableCell>{customer?.CustomerName}</TableCell>
                    <TableCell>{customer?.EmailId}</TableCell>
                    <TableCell>{customer?.Status}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Stack direction="row" spacing={1} justifyContent="center" alignItems="center" mt={2}>
              <Button
                onClick={handleCloseCustomerDialog}
                color="warning"
                startIcon={<CloseIcon />}
                variant="outlined"
                size="small"
              >
                Close
              </Button>
            </Stack>
          </DialogContent>
        </Dialog>

        {/* Add Ledger Popup */}
        <Dialog fullwidth maxWidth={'xl'} open={isDialogOpen} onClose={closeDialog}>
          <DialogTitle>
            <Typography
              variant="h5"
              p={1}
              boxShadow={1}
              borderColor="#11235A"
              textAlign={'center'}
              borderRadius={8}
              color="white"
              sx={{
                background: 'linear-gradient(to right, #4ecdc4, #556270)',
                boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
              }}
            >
              <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
                Add Ledger
              </Typography>
            </Typography>
          </DialogTitle>
          <DialogContent>
            <LedgerAdd
              setDialogOpenState={setDialogOpenState}
              getAllData={getAllData}
              countryList={countryList}
              salesPersons={salesPersons}
              allCustomerData={allCustomerData}
              GetCustomerHelpAll={GetCustomerHelpAll}
            />
          </DialogContent>
        </Dialog>
      </Container>
    </>
  );
};

export default SalesFollowupPanel;
